export default __webpack_public_path__ + "static/media/face-ok.80d23177.jpg";